"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "stateToHTML", {
  enumerable: true,
  get: function get() {
    return _stateToHTML["default"];
  }
});

var _stateToHTML = _interopRequireDefault(require("./stateToHTML"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-export-html/lib/main.js
// module id = 442
// module chunks = 1